export const collectionToCurrency = (result) => {
    return result.currencies.map((data) => objectToCurrency(data));
};
export const objectToCurrency = (data) => {
    return {
        id: data.id,
        name: data.name,
        alias: data.alias,
        symbol: data.symbol,
        exchangeRate: data.exchangeRate
    };
};
